import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import { clsx } from 'clsx';
import { FilledButton, OutlinedButton } from '@/user/components/common';
import { HomeCertification, HomeCurriculum, HomeEduIntro } from '@/user/components/molecules';
import { I18nInfo } from '@/user/models';
import { gotoAttend, gotoCertificationExamDate } from '@/user/helpers/router.helper';
import useFramedView from '@/user/components/FramedView';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeModule',
    setup(__props) {
        useFramedView();
        const t = new I18nInfo('eduCenter.home');
        const styles = {
            section: clsx('w-full px-16 py-60', 'desktop:min-w-1400 desktop:px-0 desktop:py-80'),
            section2: clsx('w-full py-60', 'desktop:min-w-1400 desktop:px-0 desktop:py-80'),
            section3: clsx('w-full px-16 py-60', 'desktop:min-w-1400 desktop:px-0 desktop:pt-100 desktop:pb-120'),
            sectionBgGray: clsx('bg-gray-100'),
            innerSection: clsx('mx-auto flex flex-col', 'desktop:w-1280'),
            sectionTitle: clsx('text-m-header-1 min-w-240', 'desktop:text-header-4'),
            section2Title: clsx('text-m-header-1 min-w-240 pl-16', 'desktop:text-header-4 desktop:pl-0'),
            buttonContainer: clsx('mt-20 flex flex-col gap-8', 'desktop:flex-row desktop:gap-16 desktop:justify-center desktop:mt-48'),
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", {
                    class: _normalizeClass(styles.section)
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.innerSection)
                    }, [
                        _createElementVNode("strong", {
                            class: _normalizeClass(styles.sectionTitle)
                        }, _toDisplayString(_unref(t).translate('sectionIntro.title')), 3),
                        _createVNode(_unref(HomeEduIntro)),
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.buttonContainer)
                        }, [
                            _createVNode(_unref(FilledButton), {
                                color: "gray",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(gotoAttend)()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t).translate('sectionIntro.button')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(OutlinedButton), {
                                color: "gray",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(gotoCertificationExamDate)()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t).translate('sectionIntro.buttonExamsLink')), 1)
                                ]),
                                _: 1
                            })
                        ], 2)
                    ], 2)
                ], 2),
                _createElementVNode("section", {
                    class: _normalizeClass([styles.section2, styles.sectionBgGray])
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.innerSection)
                    }, [
                        _createElementVNode("strong", {
                            class: _normalizeClass(styles.section2Title)
                        }, _toDisplayString(_unref(t).translate('sectionCurriculum.title')), 3),
                        _createVNode(_unref(HomeCurriculum))
                    ], 2)
                ], 2),
                _createElementVNode("section", {
                    class: _normalizeClass(styles.section3)
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.innerSection)
                    }, [
                        _createElementVNode("strong", {
                            class: _normalizeClass(styles.sectionTitle),
                            innerHTML: _unref(t).translate('sectionCertification.title')
                        }, null, 10, _hoisted_1),
                        _createVNode(_unref(HomeCertification))
                    ], 2)
                ], 2)
            ], 64));
        };
    }
});
